import Global from '../../scripts/Global'
import { Logging } from '../../scripts/Logging';
import VueSignals from '../../scripts/VueSignals';
import SessionManager from '../Session.manager';
let notification_permision_status = false;
let notificationOptions = {
    silent: false
}
// const { ipcRenderer } = require('electron');
export default class MainNotification {
    constructor(){}

    static init(){
        try {
          MainNotification.getRootWindow(window).Notification.requestPermission().then( (permission) =>
              MainNotification.initNotifications(permission)
          )
        } catch (error) {
            // Safari doesn't return a promise for requestPermissions and it
            // throws a TypeError. It takes a callback as the first argument
            // instead.
            if (error instanceof TypeError) {
                MainNotification.getRootWindow(window).Notification.requestPermission( (permission) =>
                    MainNotification.initNotifications(permission)
                )
            } else {
                throw error;
            }
        }
    }

    static initNotifications(permission) {
        Logging.Debug(permission)
        if(permission === 'granted'){
            Global.globalValue(VueSignals.NOTIFICATION_NEED_PERMISSION, false)
            Global.globalValue(VueSignals.NOTIFICATION_ALLOWED, true)
            notification_permision_status = true
        }else if (permission === 'declined') {
            Global.globalValue(VueSignals.NOTIFICATION_NEED_PERMISSION, true)
            Global.globalValue(VueSignals.NOTIFICATION_ALLOWED, true)
        }else if (permission === 'denied') {
            Global.globalValue(VueSignals.NOTIFICATION_NEED_PERMISSION, true)
            Global.globalValue(VueSignals.NOTIFICATION_ALLOWED, false)
        }
    }

    static push(title, message = '', channel_id = ''){
        let audio = new Audio(`${process.env.BASE_URL}to-the-point.mp3`);
        // if the user in online status mode
        let options = {
            silent: true,
            icon: `${process.env.BASE_URL}img/icons/Cloud-512x512.png`
        };
        if (message) {
            options['body'] = message;
        }
        if(SessionManager.getLoggedInUser().status_mode == 'online' && SessionManager.getLoggedInUser().settings.enable_instant_messaging_notification){
            try {
                audio.play()
            } catch (e) {
                console.error(e);
            }
            new Notification(title, options).onclick = (event) => {
                event.preventDefault();
                MainNotification.getRootWindow(window).focus();
                if (channel_id) {
                    SessionManager.setActiveChannelById(channel_id);
                    Global.globalValue(VueSignals.TOOGLE_TEXT_CARET, true)
                }
                // If it's running in electron, send signal to focus chat window
                // if (Global.isELectron()) {
                //     ipc.send('focus-electron-chat-tab', true);
                // }
                // Global.globalValue("open_chat", true);
            }
            Global.changeFaviconToAlert();
        }else {
            new Notification(title, options)
            Global.changeFaviconToAlert();
        }
    }

    static getStatus(){
        return MainNotification.getRootWindow(window).Notification.permission
    }

    static getRootWindow(window){
        if(window.parent === window){
            return window
        }
        return MainNotification.getRootWindow(window.parent)
    }
}
